import { Routes, Route } from "react-router-dom";

import Home from "pages/Home/Home";
import Consultancy from "pages/Consultancy/Consultancy";
import Product from "pages/Products/Product/Product";
import Video from "pages/Video/Video";
import Education from "pages/Education/Education";
import Contact from "pages/Contact/Contact";
import WorkshopDetails from "pages/Workshop/WorkshopDetail/workshopDetails";
import WorkshopDetails02 from "pages/Workshop/WorkshopDetail/Workshopdetails02";
import Workshopdetails03 from "pages/Workshop/WorkshopDetail/Workshopdetails03";
import WorkshopDetails04 from "pages/Workshop/WorkshopDetail/WorkshopDetails04";
import Workshop from "pages/Workshop/Workshop";
import Expert from "pages/Expert/Expert";
import Schedule from "pages/Schedule/Schedule";
import ProductDetail from "pages/Products/ProductDetail/ProductDetail";
import Testimonial from "pages/Testimonial/Testimonial";
import DisclaimerAndDisclosure from "pages/Legal/DisclaimerPage/Disclaimer_and_Disclosure";
import Course from "pages/Courses/Course/Course";
import CourseDetail from "pages/Courses/CourseDetail/CourseDetail";
import Institute from "pages/Institute/Institute";
import TermsAndCondition from "pages/Legal/TermsPage/Terms_and_condition";
import FeedbackForm from "pages/Home/components/FeedbackForm";
import NotFound from '../compoments/NotFound';
// import HealthChecker from "../pages/HealthChecker/HealthChecker";
import WellnessCheckBooth from "../pages/HealthChecker/HealthChecker";

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/consultancy" element={<Consultancy />} />
            <Route path="/product" element={<Product />} />
            <Route path="/video" element={<Video />} />
            <Route path="/education" element={<Education />} />
            <Route path="/contact" element={<Contact />} />
            {/* Static workshop detail pages (used when API has no data) */}
            <Route path="/workshops/healing-simplified" element={<WorkshopDetails02 />} />
            <Route path="/workshops/gardening-simplified" element={<Workshopdetails03 />} />
            <Route path="/workshops/healthy-sustainable-living-spaces-simplified" element={<WorkshopDetails04 />} />
            <Route path="/workshops/:slug" element={<WorkshopDetails />} />
            <Route path="/workshop" element={<Workshop />} />
            <Route path="/healthchecker" element={<WellnessCheckBooth    />} />
            <Route path="/expert/:slug" element={<Expert />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/products/:productName" element={<ProductDetail />} />
            <Route path="/testimonial" element={<Testimonial />} />
            <Route path="/disclaimer_and_disclosure" element={<DisclaimerAndDisclosure />} />
            <Route path="/course" element={<Course />} />
            <Route path="/courseDetail" element={<CourseDetail />} />
            <Route path="/institute" element={<Institute />} />
            <Route path="/terms_and_condition" element={<TermsAndCondition />} />
            <Route path="/#/3-day-natural-healt-retreat" element={<FeedbackForm />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

export default AppRoutes;
